import { createAction } from '@reduxjs/toolkit';

import type {
  CreateTemplatePayload,
  DeleteTemplatePayload,
  UpdateTemplatePayload,
} from '@polyai/stream/commands/handlers/sms';

const PREFIX = 'sms';

const createTemplate = createAction<CreateTemplatePayload>(
  `${PREFIX}/createTemplate`,
);

const updateTemplate = createAction<UpdateTemplatePayload>(
  `${PREFIX}/updateTemplate`,
);

const deleteTemplate = createAction<DeleteTemplatePayload>(
  `${PREFIX}/deleteTemplate`,
);

export { createTemplate, deleteTemplate, updateTemplate };
